// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Modal$ReactHooksTemplate = require("./Modal.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var ChartId$ReactHooksTemplate = require("../dashboard/dashboard/chartId.res.js");
var Filters$ReactHooksTemplate = require("../dashboard/filters/filters.res.js");
var Loading$ReactHooksTemplate = require("../dashboard/dashboard/Loading.res.js");
var DateFilter$ReactHooksTemplate = require("../dashboard/filters/dateFilter.res.js");
var ChartComponent$ReactHooksTemplate = require("../dashboard/dashboard/ChartComponent.res.js");

var initialState = {
  loading: true,
  charts: /* [] */0,
  enlargedChart: undefined,
  toggleFilter: false,
  dateRange: undefined
};

function reducer(state, x) {
  if (typeof x !== "object") {
    if (x === "FetchChartsInProgress") {
      return {
              loading: true,
              charts: state.charts,
              enlargedChart: state.enlargedChart,
              toggleFilter: state.toggleFilter,
              dateRange: state.dateRange
            };
    } else {
      return {
              loading: state.loading,
              charts: state.charts,
              enlargedChart: state.enlargedChart,
              toggleFilter: !state.toggleFilter,
              dateRange: state.dateRange
            };
    }
  }
  switch (x.TAG) {
    case "FetchChartsCompleted" :
        return {
                loading: false,
                charts: x._0,
                enlargedChart: state.enlargedChart,
                toggleFilter: state.toggleFilter,
                dateRange: state.dateRange
              };
    case "UpdateDateRange" :
        return {
                loading: state.loading,
                charts: state.charts,
                enlargedChart: state.enlargedChart,
                toggleFilter: state.toggleFilter,
                dateRange: x._0
              };
    case "EnlargeChart" :
        return {
                loading: state.loading,
                charts: state.charts,
                enlargedChart: x._0,
                toggleFilter: state.toggleFilter,
                dateRange: state.dateRange
              };
    
  }
}

function CampaignDashboard(props) {
  var campaignId = props.campaignId;
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var fetchVisualizations = function (param) {
    Curry._1(dispatch, "FetchChartsInProgress");
    return Js_promise.$$catch((function (error) {
                  console.log(error);
                  return Promise.resolve(Curry._1(dispatch, {
                                  TAG: "FetchChartsCompleted",
                                  _0: /* [] */0
                                }));
                }), Js_promise.then_((function (xs) {
                      return Promise.resolve((setTimeout((function (param) {
                                          Curry._1(dispatch, {
                                                TAG: "FetchChartsCompleted",
                                                _0: xs
                                              });
                                        }), Utils$ReactHooksTemplate.timeout), undefined));
                    }), Js_promise.then_((function (xs) {
                          Js_promise.then_((function (dateRange) {
                                  return Promise.resolve(Curry._1(dispatch, {
                                                  TAG: "UpdateDateRange",
                                                  _0: Caml_option.some(dateRange)
                                                }));
                                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/filters/date_range", DateFilter$ReactHooksTemplate.fromJson));
                          return Promise.resolve(xs);
                        }), Js_promise.then_((function (xs) {
                              console.log(xs);
                              return Promise.resolve(xs);
                            }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/campaigns/" + (campaignId + "/visualizations"), ChartId$ReactHooksTemplate.fromJson)))));
  };
  React.useEffect((function (param) {
          fetchVisualizations();
        }), []);
  var onApplyFilter = function (param) {
    fetchVisualizations();
  };
  var toggleFilter = function (param) {
    Curry._1(dispatch, "ToggleFilter");
  };
  var chartId = state.enlargedChart;
  var tmp;
  if (chartId !== undefined) {
    var chartId$1 = Caml_option.valFromOption(chartId);
    tmp = JsxRuntime.jsx(Modal$ReactHooksTemplate.make, {
          show: true,
          children: JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(ChartComponent$ReactHooksTemplate.make, {
                      chartId: chartId$1,
                      onClick: (function (param, param$1, param$2) {
                          
                        }),
                      onEnlarge: (function (param) {
                          Curry._1(dispatch, {
                                TAG: "EnlargeChart",
                                _0: Caml_option.some(chartId$1)
                              });
                        }),
                      enlarged: true,
                      campaign: true
                    }, String(ChartId$ReactHooksTemplate.id(chartId$1))),
                className: "w-screen bg-white pt-6 pb-10"
              }),
          handleClose: (function (param) {
              Curry._1(dispatch, {
                    TAG: "EnlargeChart",
                    _0: undefined
                  });
            })
        });
  } else {
    tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  var tmp$1;
  if (state.loading) {
    tmp$1 = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                img: Caml_option.some(Image$ReactHooksTemplate.dashboardLoading),
                text: "Loading Charts"
              }),
          className: "h-screen w-full"
        });
  } else {
    var chartIds = state.charts;
    tmp$1 = JsxRuntime.jsx(JsxRuntime.Fragment, {
          children: Caml_option.some(JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("img", {
                                                  className: "mr-2 h-8 w-8",
                                                  src: Image$ReactHooksTemplate.dashboardIcon
                                                }),
                                            JsxRuntime.jsx("p", {
                                                  children: "Dashboard",
                                                  className: "font-semibold text-xl text-left"
                                                })
                                          ],
                                          className: "flex items-center"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsx("div", {
                                                              children: JsxRuntime.jsx(Filters$ReactHooksTemplate.make, {
                                                                    onClose: toggleFilter,
                                                                    onApply: onApplyFilter,
                                                                    showDateFilter: true,
                                                                    showFilterPills: false
                                                                  })
                                                            }),
                                                        className: "capitalize tracking-wide"
                                                      }),
                                                  className: "bg-white"
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsxs("button", {
                                                        children: [
                                                          JsxRuntime.jsx("img", {
                                                                className: "h-14-px mr-2-px",
                                                                src: Image$ReactHooksTemplate.filterButton
                                                              }),
                                                          "Filters"
                                                        ],
                                                        className: "bg-ghostwhite border border-gray-400\n                              shadow-inner flex rounded py-2 px-3 text-xs w-20",
                                                        id: "filters",
                                                        onClick: (function (param) {
                                                            Curry._1(dispatch, "ToggleFilter");
                                                          })
                                                      })
                                                })
                                          ],
                                          className: "flex gap-4"
                                        })
                                  ],
                                  className: "flex justify-between gap-2 p-16-px"
                                }),
                            JsxRuntime.jsx("div", {
                                  children: chartIds ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                          children: [
                                            JsxRuntime.jsx("div", {
                                                  children: $$Array.of_list(Belt_List.map(Belt_List.keep(chartIds, (function (xs) {
                                                                  return ChartId$ReactHooksTemplate.visualizationType(xs) === "ScoreCard";
                                                                })), (function (chartId) {
                                                              return JsxRuntime.jsx(ChartComponent$ReactHooksTemplate.make, {
                                                                          chartId: chartId,
                                                                          onClick: (function (param, param$1, param$2) {
                                                                              
                                                                            }),
                                                                          onEnlarge: (function (param) {
                                                                              Curry._1(dispatch, {
                                                                                    TAG: "EnlargeChart",
                                                                                    _0: Caml_option.some(chartId)
                                                                                  });
                                                                            }),
                                                                          scoreCard: true,
                                                                          campaign: true
                                                                        }, ChartId$ReactHooksTemplate.name(chartId));
                                                            }))),
                                                  className: "flex flex-wrap p-16-px gap-4 pt-0"
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: $$Array.of_list(Belt_List.map(Belt_List.keep(chartIds, (function (xs) {
                                                                  return ChartId$ReactHooksTemplate.visualizationType(xs) !== "ScoreCard";
                                                                })), (function (chartId) {
                                                              return JsxRuntime.jsx(ChartComponent$ReactHooksTemplate.make, {
                                                                          chartId: chartId,
                                                                          onClick: (function (param, param$1, param$2) {
                                                                              
                                                                            }),
                                                                          onEnlarge: (function (param) {
                                                                              Curry._1(dispatch, {
                                                                                    TAG: "EnlargeChart",
                                                                                    _0: Caml_option.some(chartId)
                                                                                  });
                                                                            }),
                                                                          campaign: true
                                                                        }, String(ChartId$ReactHooksTemplate.id(chartId)));
                                                            }))),
                                                  className: "flex flex-wrap p-16-px"
                                                })
                                          ]
                                        }) : "No Charts Loaded for the Dashboard"
                                })
                          ]
                        }),
                    id: "dashboard"
                  }))
        });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                tmp,
                JsxRuntime.jsxs("div", {
                      children: [
                        state.toggleFilter ? JsxRuntime.jsx(Filters$ReactHooksTemplate.make, {
                                onClose: toggleFilter,
                                onApply: onApplyFilter,
                                showDateFilter: false,
                                showFilterPills: false
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                        tmp$1
                      ]
                    })
              ]
            });
}

var make = CampaignDashboard;

exports.initialState = initialState;
exports.reducer = reducer;
exports.make = make;
/* react Not a pure module */
